// Returns the code abbreviation or falls back to an alternative value.
// Treats empty strings and whitespace-only strings as falsy.
// Useful for displaying asset codes with a preferred abbreviation.
// Ex: `getCodeAbbreviation('BTC', 'BITCOIN')` --> `BTC`
export function getCodeAbbreviation(
  codeAbbreviation: string,
  codeAbbreviationAlternative: string,
): string {
  return codeAbbreviation.trim() || codeAbbreviationAlternative.trim();
}
